'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _dekuPopup = require('@viskan/deku-popup');

var _dekuPopup2 = _interopRequireDefault(_dekuPopup);

var _deepEqual = require('deep-equal');

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

var _methods = require('../methods');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var popupTimeout = null; /** @jsx dom */


var handleClose = function handleClose(props) {
	return function () {
		if (props.cookieControlled) {
			(0, _methods.cookieSet)(props.cookieName, props.cookieMaxAge);
		}

		props.toggle({ open: false });
	};
};

var parseIcon = function parseIcon(icon, size, label, styleClasses) {
	if (!icon) {
		return label;
	}

	var parsedIcon = JSON.parse(icon);
	var fontSize = size && size.replace(',', '.') || '';

	return (0, _magicVirtualElement2.default)(
		'div',
		{ 'class': styleClasses.Icon, 'data-style-attr': 'Icon', style: 'font-size: ' + fontSize },
		(0, _magicVirtualElement2.default)('i', { key: '' + parsedIcon.x.name + parsedIcon.prefix, 'class': parsedIcon.prefix + ' fa-' + parsedIcon.x.name })
	);
};

var parseNumber = function parseNumber(num, def) {
	return parseInt(num, 10) || def;
};

var beforeMount = function beforeMount(_ref) {
	var props = _ref.props;

	props.setStateConfiguration({
		actionDuration: props.actionDuration,
		closeOnUrlChange: props.closeOnUrlChange,
		onAction: props.onAction,
		onActionAction: props.onActionAction,
		keepOpen: props.keepOpen,
		identifier: props.identifier
	});

	if (props.openByDefault) {
		props.toggle({ open: true });
	}

	if (props.cookieControlled) {
		var delay = parseNumber(props.cookieOpenDelay, 0) * 1000;
		popupTimeout = setTimeout(function () {
			return props.toggle({ open: (0, _methods.cookieCheck)(props.cookieMaxAge, props.cookieName) });
		}, delay);
	}
};

var afterUpdate = function afterUpdate(_ref2, prevProps) {
	var props = _ref2.props;
	var cookieControlled = props.cookieControlled,
	    cookieMaxAge = props.cookieMaxAge,
	    cookieName = props.cookieName,
	    cookieOpenDelay = props.cookieOpenDelay,
	    configuration = props.configuration;

	var duration = parseInt(configuration.actionDuration, 10);
	var delay = parseNumber(cookieOpenDelay, 0) * 1000;
	var openValue = { OPEN: true, CLOSE: false };

	if (configuration && prevProps.configuration && configuration.force !== prevProps.configuration.force && configuration.force) {
		props.toggle({ open: openValue[configuration.force], removeForce: true });

		if (duration) {
			setTimeout(function () {
				return props.toggle({ open: !openValue[configuration.force] });
			}, duration);
		}
	}

	(0, _methods.cookieRemove)(cookieControlled, cookieName);

	if (cookieControlled) {
		clearTimeout(popupTimeout);
		popupTimeout = setTimeout(function () {
			return props.toggle({ open: (0, _methods.cookieCheck)(cookieMaxAge, cookieName) });
		}, delay);
	}

	if (!(0, _deepEqual2.default)({
		actionDuration: props.actionDuration,
		closeOnUrlChange: props.closeOnUrlChange,
		onAction: props.onAction,
		onActionAction: props.onActionAction,
		keepOpen: props.keepOpen,
		identifier: props.identifier
	}, {
		actionDuration: configuration.actionDuration,
		closeOnUrlChange: configuration.closeOnUrlChange,
		onAction: configuration.onAction,
		onActionAction: configuration.onActionAction,
		keepOpen: configuration.keepOpen,
		identifier: configuration.identifier
	})) {
		props.setStateConfiguration({
			actionDuration: props.actionDuration,
			closeOnUrlChange: props.closeOnUrlChange,
			onAction: props.onAction,
			onActionAction: props.onActionAction,
			keepOpen: props.keepOpen,
			identifier: props.identifier
		});
	}
};

var beforeUnmount = function beforeUnmount(_ref3) {
	var props = _ref3.props;

	props.toggle({ open: false });

	if (popupTimeout) {
		clearTimeout(popupTimeout);
	}
};

var render = function render(_ref4) {
	var props = _ref4.props;
	var cookieControlled = props.cookieControlled,
	    height = props.height,
	    iconClosed = props.iconClosed,
	    iconClosedSize = props.iconClosedSize,
	    iconOpen = props.iconOpen,
	    iconOpenSize = props.iconOpenSize,
	    iconPopupClose = props.iconPopupClose,
	    iconPopupCloseSize = props.iconPopupCloseSize,
	    id = props.id,
	    label = props.label,
	    popupCloseText = props.popupCloseText,
	    styleClasses = props.styleClasses,
	    toggle = props.toggle,
	    width = props.width;

	var children = props.children.length > 0 ? props.children : (0, _magicVirtualElement2.default)('div', { 'data-id': id, 'class': 'CMS-Popup-placeholder CMS-Component' });
	var openIcon = parseIcon(iconOpen, iconOpenSize, label, styleClasses);
	var closedIcon = parseIcon(iconClosed, iconClosedSize, label, styleClasses);
	var popupCloseIcon = parseIcon(iconPopupClose, iconPopupCloseSize, popupCloseText, styleClasses);

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['CMS-Popup-wrapper', styleClasses.Wrapper], 'data-style-attr': 'Wrapper' },
		!cookieControlled && (0, _magicVirtualElement2.default)(
			'div',
			{ 'class': ['CMS-Popup--toggle', styleClasses.Toggle], 'data-style-attr': 'Toggle', onClick: toggle },
			props.open ? openIcon : closedIcon
		),
		(0, _magicVirtualElement2.default)(
			_dekuPopup2.default,
			{ 'class': ['CMS-Popup', props.class], styleClasses: styleClasses, height: height, width: width, onClickOutside: handleClose(props), open: props.open },
			(0, _magicVirtualElement2.default)(
				'div',
				{ 'class': 'CMS-Popup--close', onClick: handleClose(props) },
				popupCloseIcon
			),
			(0, _magicVirtualElement2.default)(
				'div',
				{ 'class': ['CMS-Popup-content', styleClasses.Content], 'data-style-attr': 'Content' },
				children
			)
		)
	), props);
};

exports.default = { beforeUnmount: beforeUnmount, beforeMount: beforeMount, afterUpdate: afterUpdate, render: render };